import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(theme => ({
  inBuildAppMainContent: {
    width: '100%',
    height: '100%',
    transition: 'all 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
  },
}));
export default function PermissionDenied() {
  const classes = useStyles();
  return (
    <Box className={classes.inBuildAppMainContent} justifyContent="center">
      <Box align="center">
        <img src="/images/404.svg" />
      </Box>
      <Box align="center" mt={15}>
        <Typography style={{ fontWeight: 700, fontSize: 28, letterSpacing: 0.04, color: '#7D7D7D' }}>
          You don’t have an access to this page
        </Typography>
        <Typography style={{ fontSize: 20, letterSpacing: 0.04, marginTop: 4 }}>
          Please ask administrator to get an access.
        </Typography>
      </Box>
    </Box>
  );
}
